import { render, staticRenderFns } from "./SvgIconPlus.vue?vue&type=template&id=a568e31e"
import script from "./SvgIconPlus.vue?vue&type=script&lang=js"
export * from "./SvgIconPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports